import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import parse from 'html-react-parser';

function Activity({ transferenceActivity }) {
  return (
    <div className="documents-pannel">
      {
       transferenceActivity.map((activity) => (
         <div className="d-flex flex-column align-items-start mb-2" key={`document-item-${activity.idtransferencia_activity}`}>
           <span className="text-16 bold">
             <FontAwesomeIcon icon="flag" />
             {' '}
             {activity.titulo || 'Actividad no especificada'}
             {' '}
           </span>
           <span className="text-11 mb-2">
             {' '}
             {activity.timestamp }
             {' '}
           </span>
           <span className="text-14">{parse(activity.descripcion || 'Sin descripción')}</span>
         </div>
       ))
     }
    </div>
  );
}

Activity.propTypes = {
  transferenceActivity: PropTypes.array,
};

export default Activity;
